const updateSites = {
  toastr: 'Updated website',
  toastr1: ' has been updated successfully',
  toastrError: 'Site already registered',
  toastrError1: 'Enter another name'
};

export default updateSites;
